const splits = [/([a-zåäö0-9])([A-ZÅÄÖ])/g, /([A-ZÅÄÖ])([A-ZÅÄÖ][a-zåäö])/g];
const strip = /[^a-zåäö0-9]+/gi;

/**
 * Like param case but allows åäö
 */
const tagCase = <T extends string = string>(value: T): T => {
    const output = splits
        .reduce((result, split) => {
            result = result.replace(split, "$1-$2") as T;
            return result;
        }, value)
        .replace(strip, "-");
    return output.toLowerCase() as T;
};

export { tagCase };
